import * as React from 'react';
import { render } from 'react-dom';
import { useLoginOnStartup } from '@micro-frontend-react/employee-experience/lib/useLoginOnStartup';
import { usePageTitle } from '@micro-frontend-react/employee-experience/lib/usePageTitle';
import { ShellWithStore } from './ShellWithStore';
import { BrowserRouter } from 'react-router-dom';
import { Header } from './components/Header/Header';
import Nav from './components/Nav/Nav';
import { Main } from './components/Main';
import { CoherenceThemeProvider } from './components/CoherenceThemeProvider';
import { Routes } from './components/Routes';
import { Footer as EVLFooter } from './components/Footer/Footer';
import { FooterBase } from './components/FooterBase/FooterBase';
import { initializeCustomIcons } from './shared/initializeCustomIcons';
import { initializeCentro } from '@coherence-design-system/controls';

initializeCustomIcons();

// The locale of the HVC to be loaded, in BCP-47 format
const language = 'en';

function App(): React.ReactElement {
  useLoginOnStartup();
  usePageTitle(__APP_NAME__);

  React.useEffect(() => {
    initializeCentro(__OCV_APP_NAME__, language, __OCV_APP_ID__);
  }, []);

  return (
    <CoherenceThemeProvider>
      <BrowserRouter>
        <Header />
        <Nav />
        <Main tabIndex={-1}>
          <Routes />
        </Main>
        <FooterBase>
          <EVLFooter />
        </FooterBase>
      </BrowserRouter>
    </CoherenceThemeProvider>
  );
}

render(
  <ShellWithStore>
    <App />
  </ShellWithStore>,
  document.getElementById('app')
);
